import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import "../styles/Auth.css";

const API = "https://api.m3campus.com";

export default function Registro() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const nombre = e.target.nombre.value.trim();
    const email = e.target.email.value.trim();
    const password = e.target.password.value;
    const password2 = e.target.password2.value;

    if (password !== password2) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);

    try {
      // 1️⃣ Pedir CSRF token al backend (robusto)
      const csrfRes = await fetch(`${API}/csrf/`, {
        method: "GET",
        credentials: "include",
      });

      if (!csrfRes.ok) {
        throw new Error("No se pudo obtener CSRF token");
      }

      const csrfData = await csrfRes.json();
      const csrfToken = csrfData.csrfToken;

      // 2️⃣ Enviar registro
      const res = await fetch(`${API}/auth/register/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify({
          nombre,
          email,
          password,
        }),
      });

      const text = await res.text();
      let data = {};
      try {
        data = JSON.parse(text);
      } catch {}

      if (!res.ok) {
        throw new Error(data.detail || text || "Error registrando usuario");
      }

      // 3️⃣ Redirigir a pantalla informativa
      navigate("/revisa-tu-email");
    } catch (err) {
      setError(err.message || "Error inesperado");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth__card">
        <h2>Crear cuenta</h2>
        <p className="auth__muted">Regístrate en M3 Campus.</p>

        {error && <div className="auth__error">{error}</div>}

        <form onSubmit={onSubmit} className="auth__form">
          <label>
            Nombre
            <input
              name="nombre"
              type="text"
              placeholder="Tu nombre"
              required
            />
          </label>

          <label>
            Correo
            <input
              name="email"
              type="email"
              placeholder="tuemail@dominio.com"
              required
            />
          </label>

          <label>
            Contraseña
            <input
              name="password"
              type="password"
              placeholder="••••••••"
              required
            />
          </label>

          <label>
            Repetir contraseña
            <input
              name="password2"
              type="password"
              placeholder="••••••••"
              required
            />
          </label>

          <button
            className="auth__primary"
            type="submit"
            disabled={loading}
          >
            {loading ? "Registrando..." : "Registrarme"}
          </button>
        </form>

        <div className="auth__footer">
          <span>¿Ya tienes cuenta?</span>
          <Link to="/sesion">Iniciar sesión</Link>
        </div>
      </div>
    </div>
  );
}
